var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0072ff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gallery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.36,60H52.64A7.36,7.36,0,0,0,60,52.64V11.36A7.36,7.36,0,0,0,52.64,4H11.36A7.36,7.36,0,0,0,4,11.36V52.64A7.36,7.36,0,0,0,11.36,60ZM18,12a6,6,0,1,1-6,6A6,6,0,0,1,18,12ZM9.34,46.74,29.52,26.49a3.51,3.51,0,0,1,5,0L43.3,35.3a2.62,2.62,0,0,1,0,3.71l-4.71,4.71a2,2,0,0,0,.26,3.07,2.09,2.09,0,0,0,2.67-.3L48,40h0l6.31-6.3a1,1,0,0,1,1.72.71V48l0,0h0v3.24A4.67,4.67,0,0,1,51.37,56H14.16A6.16,6.16,0,0,1,8,50,5.16,5.16,0,0,1,9.34,46.74Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2252e710f82122893da2ea5c27432630.svg";
export { ForwardRef as ReactComponent };